/**
 * client/src/lib/payment-rail/webauthn-cancel.ts
 *
 * Tiny shared client leaf for the payment-rail WebAuthn ceremonies (#1085 review
 * dedup): the user-cancel detector + a hex encoder, both previously copied into
 * `envelope.ts` and `bank-account-transport.ts`. Centralised here so the cancel
 * heuristic (and the hash-hex helper) live in ONE place for the #1085-touched
 * transports. (Other copies elsewhere in the client are intentionally left
 * untouched to avoid scope creep — this dedups only the feature's own files.)
 */

/**
 * True when a WebAuthn ceremony rejection is a user-cancel (NotAllowedError),
 * NOT a genuine failure. @simplewebauthn's `WebAuthnError` wraps the DOMException
 * on `.cause`, so the cause name is checked as well as the top-level name
 * (reference_webauthn_browser_prf_decode_client).
 */
export function isUserCancel(err: unknown): boolean {
  if (!(err instanceof Error)) return false;
  const cause = err.cause as { name?: string } | undefined;
  return err.name === "NotAllowedError" || cause?.name === "NotAllowedError";
}

/** Lowercase hex encoding of a byte array (e.g. a pubkey-hash digest). */
export function hex(bytes: Uint8Array): string {
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
